<template>
    <section class="test-drive" id="target-select">
        <template v-if="success == false">
            <PreviousStep />
        </template>
        <div v-if="success == false" class="confirm-details__content">
            <div class="confirm-details__content--details">
                <selected-vehicle-details :model="model" :formSubmitted="success"></selected-vehicle-details>
            </div>
            <div class="confirm-details__content--form">
                <div class="card">
                    <form  @submit.prevent="submit" ref="form" class="card__inner">
                        <h2 class="confirm-details__title title">Please enter your details to book your 24 hour test drive experience</h2>
                        <div class="form-grid form-grid--xs-1-column">
                            <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                <title-input />
                            </div>
                            <div class="form-grid__col form-grid__col--xs-full-width">
                                <first-name />
                            </div>
                            <div class="form-grid__col form-grid__col--xs-full-width">
                                <last-name />
                            </div>
                            <div class="form-grid__col form-grid__col--xs-full-width">
                                <email />
                            </div>
                            <div class="form-grid__col form-grid__col--xs-full-width">
                                <telephone :inputNullable="false" inputValidateMessage="Please enter a telephone number" />
                            </div>
                            <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                <privacy />
                            </div>
                            <div class="form-grid__col-span-2 form-grid__col--xs-full-width confirm-details__content--button">
                                <button type="button" @click="submit" class="btn btn--primary confirm-details__button">BOOK A TEST DRIVE</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div v-else class="thank-you__content">
            <h2 class="title thank-you__title">
                Thanks for your <span class="capitalise">{{ model.model_title }}</span> 24 Hour test drive request
            </h2>
            <p class="thank-you__description">
                A member of the team will be in contact shortly to confirm your appointment. The vehicle you test drive will be dependant on availability but every effort will be made to meet your preferred selections. We hope you enjoy your {{ model.model_title }} test drive.
            </p>
            <div class="thank-you__button-container">
                <a :href="'/' + dealer.full_slug" class="btn btn--primary" target="_blank">Contact Dealer</a>
                <a :href="directionsLink" class="btn btn--primary-inverted" target="_blank">Get Directions</a>
            </div>
            <div class="thank-you__content-details">
                <div class="thank-you__details-image">
                    <picture>
                        <source v-if="model.image_webp" :srcset="model.image_webp" type="image/webp" />
                        <img class="img-responsive select-model__image" :src="model.image" :alt="model.model_title" />
                    </picture>
                    <h3 class="thank-you__details-model-name capitalise">{{ model.model_title }}</h3>
                </div>
                <div>
                    <div class="thank-you__details-container">
                        <div class="thank-you__booking-details">
                            <h3 class="thank-you__title">Booking Date & Time:</h3>
                            <div class="thank-you__body">
                                <p>
                                    <span><img src="/images/articles/electric-vehicles/calendar-icon.svg" width="30" height="19" border="0" alt="" style="display: inline-block; vertical-align: middle;" /></span> {{ date }} <br />
                                    <span><img src="/images/articles/electric-vehicles/clock-icon.svg" width="30" height="19" border="0" alt="" style="display: inline-block; vertical-align: middle;" /></span> {{ time }}
                                </p>
                            </div>
                        </div>
                        </div>
                        <div class="thank-you__dealer-details">
                            <h3 class="thank-you__title">Your chosen dealership:</h3>
                            <div class="thank-you__body thank-you__dealer ">
                                <div><img src="/images/articles/electric-vehicles/map-pin-icon.svg" width="30" height="19" border="0" alt="" style="display: inline-block; vertical-align: middle;" /></div>
                                <div>
                                    <p>
                                    {{ dealer.name }} <br />
                                    {{ dealer.address }},
                                    {{ dealer.postcode }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
        </div>
    </section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import SelectedVehicleDetails from "../SelectedVehicleDetails.vue"
import PreviousStep from "../PreviousStep.vue";
import TitleInput from "../../../../core/components/Forms/Title.vue";
import FirstName from "../../../../core/components/Forms/FirstName.vue";
import LastName from "../../../../core/components/Forms/LastName.vue";
import Email from "../../../../core/components/Forms/Email.vue";
import Telephone from "../../../../core/components/Forms/Telephone.vue";
import Privacy from '../../../../core/components/Forms/Privacy.vue';
import { customEvent, generateLeadEvent } from '../../../../modules/tracking/AnalyticsEvents';


export default {
    components: {
        PreviousStep,
        SelectedVehicleDetails,
        TitleInput,
        FirstName,
        LastName,
        Email,
        Telephone,
        Privacy
    },
    data() {
        return {
            acceptedTermsAndConditions: false,
            validator: false,
            success:false,
        };
    },
    created() {
        this.$nextTick(() => {
            this.scrollToTop();
        });
    },
    mounted() {
        this.validator = new ContactFormValidator({
            element: $(this.$refs.form),
            vueForm: true,
        });

        if (this.detailsPage === true) {
            customEvent("Electric Car - Test Drive Form", "Revisit", "Details Page");
        } else {
            customEvent("Electric Car - Test Drive Form", "Visited", "Details Page");
            this.$store.commit("setDetailsPage", true);
        }
    },
    methods: {
        async submit() {
            if (!await this.validator.isValid()) {
                return;
            }
            const formData = new FormData(this.$refs.form);
            formData.set("brand", this.model.brand);
            formData.set("fuelChoice", this.model.fuel_type);
            formData.set("transmissionChoice", this.model.transmission);
            try {
                formData.set("date", this.date);
            } catch (error) {
                console.error(error);
            }
            formData.set("time", this.time);
            formData.set("location", this.customerAddress);
            formData.set("location-id", this.dealer.id);
            formData.set("24hr-test-drive", true);
            this.$store.dispatch("navigatorStep", this.currentStep.next);
            this.validator.preventInput();

            axios
                .post("/api/test-drive/" + this.model.new_model_id, formData)
                .then(response => {
                    this.validator.allowInput();
                    customEvent("New Car - Test Drive Form", "Submit", "Complete");
                    generateLeadEvent('new_test_drive');
                    this.$store.commit("setDealerDirectionsLink", response.data.directions_link);
                    this.success = true
                })
                .catch((error) => {
                    console.error(error);
                    this.validator.errorResponse(error);
                });
        },
        scrollToTop() {
            const storedPosition = this.scrollPosition;
            if (storedPosition) {
                window.scrollTo({ top: storedPosition, behavior: 'smooth' });
            }
        },
    },
    computed: {
        ...mapGetters(["currentStep", 'currentOptions', 'model']),
        ...mapState(["dealer", "customerAddress", "date", "time", 'searchDate', 'directionsLink', 'detailsPage', 'scrollPosition']),

        title: {
            get() {
                return this.$store.state.title;
            },
            set(value) {
                this.$store.commit("setTitle", value);
            },
        },
        firstName: {
            get() {
                return this.$store.state.firstName;
            },
            set(value) {
                this.$store.commit("setFirstName", value);
            },
        },
        lastName: {
            get() {
                return this.$store.state.lastName;
            },
            set(value) {
                this.$store.commit("setLastName", value);
            },
        },
        email: {
            get() {
                return this.$store.state.email;
            },
            set(value) {
                this.$store.commit("setEmail", value);
            },
        },
        phone: {
            get() {
                return this.$store.state.phone;
            },
            set(value) {
                this.$store.commit("setPhone", value);
            },
        },
        contactMethod: {
            get() {
                return this.$store.state.contactMethod;
            },
            set(value) {
                this.$store.commit("setContactMethod", value);
            },
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/electric-test-drive/steps/Details.vue